import { Component } from "@angular/core";
import { AbstractButtonComponent } from "./abstract-button.component";

@Component({
    selector: 'standard-button',
    template: `
    <button mat-flat-button (click)="buttonClick.emit()" [disabled]="disabled" [ngClass]="cssClass" [class.btn-critical]="critical" [disableRipple]="true">
        <span [custom-label]="label"></span>
    </button>`,
    styles: [require('./button.component.css'), require('./standard-button.component.css')]
})
export class StandardButtonComponent extends AbstractButtonComponent { }